export default {
  GET_REQUIRES_TRIAGE: 'GET_REQUIRES_TRIAGE',
  OPEN_CASE: 'OPEN_CASE',
  POST_REPORT_CHANGES: 'POST_REPORT_CHANGES',
  GET_REPORT_ANSWERS: 'GET_REPORT_ANSWERS',
  GET_CASE_TYPE_QUESTIONS: 'GET_CASE_TYPE_QUESTIONS',
  UPDATE_TRIAGE_LEVEL: 'UPDATE_TRIAGE_LEVEL',
  GET_USERS_REPORTS: 'GET_USERS_REPORTS',
  GET_ADMIN_REPORTS: 'GET_ADMIN_REPORTS',
  GET_ARCHIVED_REPORTS: 'GET_ARCHIVED_REPORTS',
  GET_REPORT_TEAM: 'GET_REPORT_TEAM',
  GET_CASE_TYPES_QUESTIONS: 'GET_CASE_TYPES_QUESTIONS',
}
